import { Box, HStack, Skeleton, Stack } from '@chakra-ui/react';
import clsx from 'clsx';
import { InfoFilledIcon } from 'icons';
import { Tooltip } from 'library/atoms';
import React from 'react';
import { useGetAnalyticsTotalSilencedCount } from 'views/main/organization/analytics-v3/hooks/useGetAnalyticsData';
import { AnalyticsTabContainer } from './style';

function NoiseReductionTab({
  title,
  isOrgAnalytics = false,
}: {
  title: string;
  isOrgAnalytics?: boolean;
}) {
  const { data, isLoading } = useGetAnalyticsTotalSilencedCount({ isOrgAnalytics });
  const formatedTotalIncidents = new Intl.NumberFormat('en-US').format(data?.silencedCount ?? 0);
  const delta = data?.reductionPercentage ?? 0;

  const deltaPercentage =
    delta > 0
      ? `${delta}% more than prev. time period`
      : delta < 0
      ? `${Math.abs(delta)}% less than prev. time period`
      : '';

  return (
    <React.Fragment>
      <Box mt={3}>
        <AnalyticsTabContainer>
          <HStack alignItems="center" columnGap={1}>
            <p className="incidents-title">{title}</p>
            <Tooltip
              label="Count of deduped, suppressed, intelligently grouped, and transient alerts."
              placement="top"
              shouldWrapChildren
            >
              <InfoFilledIcon width={16} height={16} />
            </Tooltip>
          </HStack>
          {isLoading ? (
            <Stack className="incidents-value">
              <Skeleton height="48px" width="100px" startColor="#EDF2F7" endColor="#EDF2F8" />
            </Stack>
          ) : (
            <p className="incidents-value">{formatedTotalIncidents}</p>
          )}
          {isLoading ? (
            <Stack className="incidents-delta">
              <Skeleton height="14px" width="100px" startColor="#EDF2F7" endColor="#EDF2F8" />
            </Stack>
          ) : (
            <p
              className={clsx(
                'incidents-delta',
                delta > 0 ? 'incidents-delta-positive' : 'incidents-delta-negative',
              )}
              data-testid="incidents-delta"
            >
              {deltaPercentage}
            </p>
          )}
        </AnalyticsTabContainer>
      </Box>
    </React.Fragment>
  );
}

export default NoiseReductionTab;
